import { createRouter, createWebHistory } from 'vue-router';
import { routeGuide } from '../auth/authGuard';

import routes from './routes';

const router = createRouter({
    history: createWebHistory('/'),
    routes,
});

router.beforeEach(routeGuide);

export default router;
